/**
 * Apple Pay utility functions
 * Provides generic helpers for Apple Pay availability detection
 * Provider-specific configurations should be handled in their respective utils (e.g., adyen.js)
 */

/**
 * Check if Apple Pay is available on this device.
 * Apple Pay requires Safari on macOS 10.14.1+ or iOS 12.2+.
 * This is a generic check that works regardless of the payment provider (Adyen, Stripe, etc.)
 * @returns {boolean} True if Apple Pay is available.
 */
export function isApplePayAvailable() {
  if (typeof window === 'undefined') {
    return false;
  }

  if (!window.ApplePaySession) {
    return false;
  }

  try {
    return window.ApplePaySession.canMakePayments();
  } catch (error) {
    console.error('Error checking Apple Pay availability:', error);
    return false;
  }
}

export default {
  isApplePayAvailable,
};
